import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@mm-aggregator/drf-dynamics';

export type TopupScope = 'WALLET_ONLY' | 'INTEGRATION_ONLY' | 'WALLET_AND_INTEGRATION';

export type FundingSource = 'OPERATOR_DIRECT' | 'BANK_WIRE' | 'INTERNAL_TRANSFER';

export interface MerchantFundingTopupRecord {
  id: string;
  amount: string;
  topup_scope: TopupScope;
  funding_source: FundingSource;
  market_currency_code?: string;
  financial_entity_code?: string | null;
  topped_up_at: string;
  reference?: string;
  notes?: string;
}

export interface MerchantFundingCreateRequest {
  amount: string;
  topped_up_at: string;
  topup_scope: TopupScope;
  funding_source: FundingSource;
  market_currency?: string;
  market_currency_code?: string;
  wallet?: string;
  financial_entity?: string;
  api_provider?: string;
  reference?: string;
  notes?: string;
}

export interface WalletFundRequest extends MerchantFundingCreateRequest {
  financial_entity?: string;
}

@Injectable({ providedIn: 'root' })
export class MerchantFundingService {
  private readonly api = inject(ApiService);

  list(params?: Record<string, string>): Observable<MerchantFundingTopupRecord[]> {
    return this.api.get<MerchantFundingTopupRecord[]>('finances/merchant-funding-topups/', params);
  }

  create(body: MerchantFundingCreateRequest): Observable<MerchantFundingTopupRecord> {
    return this.api.post<MerchantFundingTopupRecord>('finances/merchant-funding-topups/', body);
  }

  fundWallet(walletId: string, body: WalletFundRequest): Observable<MerchantFundingTopupRecord> {
    return this.api.post<MerchantFundingTopupRecord>(`finances/wallets/${walletId}/fund/`, body);
  }
}
